import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateHabitMutationVariables = Types.Exact<{
  data: Types.CreateMetricInput;
}>;


export type CreateHabitMutation = { createMetric?: { metric?: { id: string, name: string } | null } | null };


export const CreateHabitDocument = /*#__PURE__*/ gql`
    mutation createHabit($data: CreateMetricInput!) {
  createMetric(data: $data) {
    metric {
      id
      name
    }
  }
}
    `;

export function useCreateHabitMutation() {
  return Urql.useMutation<CreateHabitMutation, CreateHabitMutationVariables>(CreateHabitDocument);
};